<app-custom-table
  class="side-scroll-table availability-management-custom-table">
  <app-custom-date-table-header
    *ngIf="
      availabilityManagementService.calendarTableHelper$
        | async as calendarTableHelper
    "
    [calendarTableHelper]="calendarTableHelper"
    (dayIndexSelected)="selectDay($event)"
    [activeDayIndex]="
      (selectedDayIndex$ | async) ?? undefined
    "></app-custom-date-table-header>
  <ng-container
    *ngIf="!(availabilityManagementService.departmentGroups$ | async)">
    <mat-spinner
      diameter="24"
      data-cy="organisations-loading-spinner"></mat-spinner>
  </ng-container>
  <ng-container
    *ngIf="
      (availabilityManagementService.departmentGroups$ | async) &&
      !(availabilityManagementService.departmentGroups$ | async)?.length &&
      !(availabilityManagementService.loadingDepartmentUsers$ | async)
    ">
    <div class="custom-table-row">
      {{ ("noUsersFound" | i18n) || "Keine Mitarbeiter gefunden" }}
    </div>
  </ng-container>
  <ng-container
    *ngFor="
      let departmentGroup of availabilityManagementService.departmentGroups$
        | async;
      trackBy: trackByDepartmentId
    ">
    <app-accordion
      [attr.data-cy]="'availability-accordion-' + departmentGroup.department.id"
      (accordionToggled)="
        accordionToggled($event, departmentGroup.department.id)
      "
      [collapsed]="
        departmentGroup.department.id !==
        (currentCollapsedDepartmentId$ | async)
      "
      class="availability-accordion">
      <app-accordion-header
        [collapseOnHeaderClick]="true"
        [displayArrowButton]="false"
        class="availability-accordion-header"
        [attr.data-cy]="'department-header-' + departmentGroup.department.id"
        ><div class="custom-table-row">
          <mat-icon
            class="collapse-toggle"
            [class.rotate]="
              departmentGroup.department.id ===
              (currentCollapsedDepartmentId$ | async)
            "
            svgIcon="chevron-down"></mat-icon>
          {{
            (mappedDepartmentNames$ | async)?.get(
              departmentGroup.department.id
            ) || departmentGroup.departmentDisplayName
          }}
          <div class="flex-spacer"></div>
        </div>
      </app-accordion-header>
      <app-accordion-content>
        <ng-container
          *ngIf="
            departmentGroup.displayLimitUsers?.length &&
            departmentGroup.department.id ===
              (currentCollapsedDepartmentId$ | async)
          ">
          <ng-container
            class="user-details mt-1"
            *ngFor="
              let rawUser of departmentGroup.displayLimitUsers;
              trackBy: trackById;
              let index = index;
              let last = last
            ">
            <ng-container
              *ngIf="
                departmentGroup.renderedUserIds.has(rawUser._id) &&
                  departmentGroup.preparedUserById.get(rawUser._id) as user;
                else userListItemSkeleton
              ">
              <app-custom-table-row
                class="table-row"
                [attr.data-cy]="'user-table-row-' + user._id">
                <app-custom-table-cell
                  class="table-cell main-label-cell sticky-main-cell-left">
                  <div
                    class="name"
                    (click)="toggleDetails(user)">
                    <div [title]="user.firstName + ' ' + user.lastName">
                      {{ formatUserName(user) }}
                    </div>
                    <div
                      *ngIf="user.customerOfUser"
                      [title]="user.customerOfUser.name"
                      class="source-customer"
                      [attr.data-cy]="
                        'source-customer-' + user.customerOfUser._id
                      ">
                      {{ "via " + user.customerOfUser.name }}
                    </div>
                    <mat-chip
                      *ngIf="
                          user.customerInformation?.[loggedInUser?.customerId || ''] &&
                          user.customerInformation?.[loggedInUser?.customerId || '']?.poolerType
                      "
                      tooltipPosition="above"
                      [matTooltip]="user.customerInformation?.[loggedInUser!.customerId]!.poolerType!.displayName | uppercase">
                      {{user.customerInformation?.[loggedInUser?.customerId || '']?.poolerType?.displayName | uppercase}}
                    </mat-chip>
                    <div
                      *ngIf="user.past3MonthsBookedCount"
                      class="previous-job-counter"
                      (click)="openPreviousJobsSheet(user)">
                      <mat-icon svgIcon="suitcase-job-history-clock"></mat-icon>
                      <span>{{
                        user.past3MonthsBookedCount +
                          " / " +
                          user.past3MonthsBookedInOrganisationCount
                      }}</span>
                    </div>
                  </div>
                  <div class="counts">
                    <div
                      class="count"
                      matTooltipPosition="above"
                      matTooltipShowDelay="350"
                      [matTooltip]="
                        ('availabilityOverviewBookedCounts' | i18n) ||
                        'gebucht in / total'
                      ">
                      <div class="number">
                        {{ user.totalDepartmentBookedCount }} /
                        {{ user.totalWorkingCount }}
                      </div>
                      <div
                        class="color-indicator"
                        title="{{ ('booked' | i18n) || 'gebucht' }}">
                        <div class="circle circle-yellow"></div>
                      </div>
                    </div>
                    <div class="count">
                      <div class="number">
                        {{ user.totalDepartmentAvailableCount }}
                      </div>
                      <div
                        class="color-indicator"
                        title="{{ ('available' | i18n) || 'verfügbar' }}">
                        <div class="circle circle-green"></div>
                      </div>
                    </div>
                  </div>
                </app-custom-table-cell>
                <ng-container
                  *ngIf="
                    departmentGroup.department.id ===
                      (currentCollapsedDepartmentId$ | async) &&
                    (customer$ | async) as customer
                  ">
                  <app-custom-table-cell
                    *ngFor="
                      let userAvailability of user.availabilities;
                      let dayIndex = index;
                      trackBy: trackByDate
                    "
                    class="table-cell shifts-grid"
                    [class.weekday-saturday]="
                      (userAvailability.date | date: 'cc') === '6'
                    "
                    [class.weekday-sunday]="
                      (userAvailability.date | date: 'cc') === '0'
                    "
                    [class.first-day-of-month]="
                      (userAvailability.date | date: 'd') === '1'
                    "
                    [class.last-day-of-month]="
                      userAvailability.date | lastOfMonth
                    "
                    [class.selected]="
                      dayIndex === ((selectedDayIndex$ | async) ?? undefined)
                    ">
                    <ng-container *ngIf="userAvailability.shifts">
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.EARLY] === 'AVAILABLE'&& (departmentGroup?.hasShifts?.[shiftEnum.EARLY] || !userAvailability.bookedJobs )
                        "
                        [class.selected]="
                          (multiCreationSelection$ | async)?.selection?.has(
                            getSelectionMapKey(
                              user,
                              shiftEnum.EARLY,
                              userAvailability.date
                            )
                          )
                        "
                        [class.disabled]="
                          !departmentGroup?.hasShifts?.[shiftEnum.EARLY] || false
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.EARLY]
                          ]
                        "
                        class="shift-badge early-shift"
                        [matTooltipPosition]="'above'"
                        [matTooltip]="
                          getAvailabilityBadgeTooltip(
                            user,
                            departmentGroup,
                            shiftEnum.EARLY
                          )
                        "
                        [class.interactable]="departmentGroup.canCreateJobs"
                        [matMenuTriggerFor]="shiftSelectionMenu"
                        #matMenuTrigger="matMenuTrigger"
                        (click)="
                          clickAvailability(
                            departmentGroup,
                            user,
                            shiftEnum.EARLY,
                            userAvailability,
                            matMenuTrigger
                          )
                        "
                        [attr.data-cy]="
                          'early-shift-' +
                          userAvailability.shifts[
                            shiftEnum.EARLY
                          ]?.toLocaleLowerCase()
                        ">
                        F
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.EARLY] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.EARLY]?.departmentId === departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.EARLY]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.EARLY]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.EARLY]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.EARLY]
                          ]
                        "
                        class="shift-badge early-shift booked"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'early-shift-' +
                          userAvailability.shifts[
                            shiftEnum.EARLY
                          ]?.toLocaleLowerCase()
                        "
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.EARLY]?.jobId]">
                        F
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.EARLY] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.EARLY]?.departmentId !== departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.EARLY]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.EARLY]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.EARLY]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.EARLY]
                          ]
                        "
                        class="shift-badge early-shift booked-other"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'early-shift-' +
                          userAvailability.shifts[
                            shiftEnum.EARLY
                          ]?.toLocaleLowerCase()
                        "
                        matTooltipPosition="above"
                        matTooltipShowDelay="350"
                        [matTooltip]="(('bookedIn' | i18n) || 'gebucht in ') + (mappedDepartmentNames$ | async)?.get(userAvailability.bookedJobs?.[shiftEnum.EARLY]?.departmentId || '')"
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.EARLY]?.jobId]">
                        F
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.DAY] === 'AVAILABLE' && (departmentGroup?.hasShifts?.[shiftEnum.DAY] || !userAvailability.bookedJobs )
                        "
                        [class.selected]="
                          (multiCreationSelection$ | async)?.selection?.has(
                            getSelectionMapKey(
                              user,
                              shiftEnum.DAY,
                              userAvailability.date
                            )
                          )
                        "
                        [class.disabled]="
                          !departmentGroup?.hasShifts?.[shiftEnum.DAY] || false
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.DAY]
                          ]
                        "
                        class="shift-badge day-shift"
                        [matTooltipPosition]="'above'"
                        [matTooltip]="
                          getAvailabilityBadgeTooltip(
                            user,
                            departmentGroup,
                            shiftEnum.DAY
                          )
                        "
                        [class.interactable]="departmentGroup.canCreateJobs"
                        [matMenuTriggerFor]="shiftSelectionMenu"
                        #matMenuTrigger="matMenuTrigger"
                        (click)="
                          clickAvailability(
                            departmentGroup,
                            user,
                            shiftEnum.DAY,
                            userAvailability,
                            matMenuTrigger
                          )
                        "
                        [attr.data-cy]="
                          'day-shift-' +
                          userAvailability.shifts[
                            shiftEnum.DAY
                          ]?.toLocaleLowerCase()
                        ">
                        M
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.DAY] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.DAY]?.departmentId === departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.DAY]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.DAY]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.DAY]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.DAY]
                          ]
                        "
                        class="shift-badge day-shift booked"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'day-shift-' +
                          userAvailability.shifts[
                            shiftEnum.DAY
                          ]?.toLocaleLowerCase()
                        "
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.DAY]?.jobId]">
                        M
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.DAY] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.DAY]?.departmentId !== departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.DAY]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.DAY]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.DAY]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.DAY]
                          ]
                        "
                        class="shift-badge day-shift booked-other"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'day-shift-' +
                          userAvailability.shifts[
                            shiftEnum.DAY
                          ]?.toLocaleLowerCase()
                        "
                        matTooltipPosition="above"
                        matTooltipShowDelay="350"
                        [matTooltip]="(('bookedIn' | i18n) || 'gebucht in ') + (mappedDepartmentNames$ | async)?.get(userAvailability.bookedJobs?.[shiftEnum.DAY]?.departmentId || '')"
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.DAY]?.jobId]">
                        M
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.LATE] === 'AVAILABLE'&& (departmentGroup?.hasShifts?.[shiftEnum.LATE] || !userAvailability.bookedJobs )
                        "
                        [class.selected]="
                          (multiCreationSelection$ | async)?.selection?.has(
                            getSelectionMapKey(
                              user,
                              shiftEnum.LATE,
                              userAvailability.date
                            )
                          )
                        "
                        [class.disabled]="
                          !departmentGroup?.hasShifts?.[shiftEnum.LATE] || false
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.LATE]
                          ]
                        "
                        class="shift-badge late-shift"
                        [matTooltipPosition]="'above'"
                        [matTooltip]="
                          getAvailabilityBadgeTooltip(
                            user,
                            departmentGroup,
                            shiftEnum.LATE
                          )
                        "
                        [class.interactable]="departmentGroup.canCreateJobs"
                        [matMenuTriggerFor]="shiftSelectionMenu"
                        #matMenuTrigger="matMenuTrigger"
                        (click)="
                          clickAvailability(
                            departmentGroup,
                            user,
                            shiftEnum.LATE,
                            userAvailability,
                            matMenuTrigger
                          )
                        "
                        [attr.data-cy]="
                          'late-shift-' +
                          userAvailability.shifts[
                            shiftEnum.LATE
                          ]?.toLocaleLowerCase()
                        ">
                        S
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.LATE] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.LATE]?.departmentId === departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.LATE]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.LATE]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.LATE]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.LATE]
                          ]
                        "
                        class="shift-badge late-shift booked"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'late-shift-' +
                          userAvailability.shifts[
                            shiftEnum.LATE
                          ]?.toLocaleLowerCase()
                        "
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.LATE]?.jobId]">
                        S
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.LATE] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.LATE]?.departmentId !== departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.LATE]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.LATE]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.LATE]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.LATE]
                          ]
                        "
                        class="shift-badge late-shift booked-other"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'late-shift-' +
                          userAvailability.shifts[
                            shiftEnum.LATE
                          ]?.toLocaleLowerCase()
                        "
                        matTooltipPosition="above"
                        matTooltipShowDelay="350"
                        [matTooltip]="(('bookedIn' | i18n) || 'gebucht in ') + (mappedDepartmentNames$ | async)?.get(userAvailability.bookedJobs?.[shiftEnum.LATE]?.departmentId || '')"
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.LATE]?.jobId]">
                        S
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.NIGHT] === 'AVAILABLE'&& (departmentGroup?.hasShifts?.[shiftEnum.NIGHT] || !userAvailability.bookedJobs )
                        "
                        [class.selected]="
                          (multiCreationSelection$ | async)?.selection?.has(
                            getSelectionMapKey(
                              user,
                              shiftEnum.NIGHT,
                              userAvailability.date
                            )
                          )
                        "
                        [class.disabled]="
                          !departmentGroup?.hasShifts?.[shiftEnum.NIGHT] || false
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.NIGHT]
                          ]
                        "
                        class="shift-badge night-shift"
                        [matTooltipPosition]="'above'"
                        [matTooltip]="
                          getAvailabilityBadgeTooltip(
                            user,
                            departmentGroup,
                            shiftEnum.NIGHT
                          )
                        "
                        [class.interactable]="departmentGroup.canCreateJobs"
                        [matMenuTriggerFor]="shiftSelectionMenu"
                        #matMenuTrigger="matMenuTrigger"
                        (click)="
                          clickAvailability(
                            departmentGroup,
                            user,
                            shiftEnum.NIGHT,
                            userAvailability,
                            matMenuTrigger
                          )
                        "
                        [attr.data-cy]="
                          'night-shift-' +
                          userAvailability.shifts[
                            shiftEnum.NIGHT
                          ]?.toLocaleLowerCase()
                        ">
                        N
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.NIGHT] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.departmentId === departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.NIGHT]
                          ]
                        "
                        class="shift-badge night-shift booked"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'night-shift-' +
                          userAvailability.shifts[
                            shiftEnum.NIGHT
                          ]?.toLocaleLowerCase()
                        "
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.jobId]">
                        N
                      </div>
                      <div
                        *ngIf="
                          userAvailability.shifts[shiftEnum.NIGHT] ===
                            'WORKING' &&
                          userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.departmentId !== departmentGroup.department.id &&
                          (customer$ | async) &&
                          (
                            userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.inviteeCustomerId === customer._id ||
                            userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.organisationOwnerCustomerIds?.includes(customer._id) ||
                            userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.creatorCustomerId === customer._id
                          )
                        "
                        [class.pending-invitation]="
                          (pendingInvitations$ | async)?.[
                            user._id +
                              userAvailability.date +
                              departmentGroup.department.id +
                              shiftEnum[shiftEnum.NIGHT]
                          ]
                        "
                        class="shift-badge night-shift booked-other"
                        title="{{ ('booked' | i18n) || 'gebucht' }}"
                        [attr.data-cy]="
                          'night-shift-' +
                          userAvailability.shifts[
                            shiftEnum.NIGHT
                          ]?.toLocaleLowerCase()
                        "
                        matTooltipPosition="above"
                        matTooltipShowDelay="350"
                        [matTooltip]="(('bookedIn' | i18n) || 'gebucht in ') + (mappedDepartmentNames$ | async)?.get(userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.departmentId || '')"
                        [routerLink]="['/', 'jobs', userAvailability.bookedJobs?.[shiftEnum.NIGHT]?.jobId]">
                        N
                      </div>
                    </ng-container>
                  </app-custom-table-cell>
                </ng-container>
              </app-custom-table-row>
              <app-custom-table-row
                class="table-row details-table-row"
                *ngIf="!user.detailsCollapsed"
                [attr.data-cy]="'user-list-item-details-' + user._id">
                <user-list-item-details
                  class="user-details mt-1"
                  [user]="user"></user-list-item-details>
              </app-custom-table-row>
            </ng-container>
          </ng-container>
          <app-custom-table-row
            class="load-more-on-visible"
            (appVisible)="displayMoreEntries()">
            <app-custom-table-cell
              *ngFor="let day of days$ | async"
              class="table-cell shifts-grid">
            </app-custom-table-cell>
          </app-custom-table-row>
        </ng-container>
        <ng-container
          *ngIf="
            departmentGroup.displayLimitUsers?.length === 0 &&
            (employmentUsersReady$ | async)
          ">
          <div class="pb-2">
            {{ ("noPoolerFound" | i18n) || "Keine Pooler gefunden" }}
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            departmentGroup.displayLimitUsers?.length === 0 &&
            !(employmentUsersReady$ | async)
          ">
          <div class="custom-table-row">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        </ng-container>
      </app-accordion-content>
    </app-accordion>
    <ng-container>
      <div class="pb-2"></div>
    </ng-container>
  </ng-container>
</app-custom-table>

<mat-menu
  #shiftSelectionMenu="matMenu"
  (closed)="shiftSelectionMenuOptions$.next([])">
  <ng-template matMenuContent>
    <button
      *ngFor="let option of shiftSelectionMenuOptions$ | async"
      mat-menu-item
      [attr.data-cy]="'shift-selection-menu-item-' + option.shift.id"
      (click)="
        clickAvailability(
          option.departmentGroup,
          option.user,
          option.shiftEnum,
          option.userAvailability,
          undefined,
          option.shift
        )
      ">
      {{
        option.shift.label ||
          ("shifts." + option.shift.shift | i18n) ||
          shiftEnum[option.shift.shift] | titlecase
      }}
      <span class="shift-time"
        >{{ option.shift.from | time }} - {{ option.shift.to | time }}</span
      >
    </button>
  </ng-template>
</mat-menu>

<ng-template #userListItemSkeleton>
  <app-availabilities-user-list-skeleton
    [days]="
      (days$ | async)?.length || 1
    "></app-availabilities-user-list-skeleton>
</ng-template>
